export default __webpack_public_path__ + "static/media/female_user.5b4ebe90.png";